import DashboardFiltersModule from "./dashboardFiltersModule";
import DashboardFiltersSagas from "./redux/dashboardFiltersSaga";
import DashboardFiltersReducer from "./redux/dashboardFiltersReducer";

export default {
  Component: DashboardFiltersModule,
  moduleName: "dashboardFilters",
  saga: DashboardFiltersSagas(),
  reducer: DashboardFiltersReducer
};
